import React                    from 'react';
import { browserHistory }       from 'react-router';
import GlobalHeader             from '../Fragments/GlobalHeader';
import HeaderSteps              from '../Fragments/HeaderSteps';
import ButtonChoice             from '../Fields/ButtonChoice';
import PreviousClaimChoice      from '../Fields/PreviousClaimChoice';
import MoneyInput               from '../Fields/MoneyInput';
import SubmitButton             from '../Fields/SubmitButton';
import SelectElement            from '../Fields/SelectElement';
import CountrySelectElement     from '../Fields/CountrySelectElement';
import DateOfBirth              from '../Fields/DateOfBirth';
import EmailInput               from '../Fields/EmailInput';
import TextInput                from '../Fields/TextInput';
import NumberInput              from '../Fields/NumberInput';
import AddressEntry             from '../Fragments/AddressEntry';
import CorAddressEntry          from '../Fragments/CorAddressEntry';
import DataProtection           from '../Fragments/DataProtection';
import Popup                    from '../Modals/Popup'; 

let ProductCover =  require('../Managers/ProductCover');
let Quote =         require('../Managers/Quote');
let QuoteError =    require('../Managers/QuoteError');
let Questions =     require('../Managers/Questions');
let StepManager =   require('../Managers/Steps');
let ReactGA =       require('react-ga');
let HttpService =   require('../Managers/HttpService');

const Config = HttpService.getConfigForHost();
const QuestionsScreen = React.createClass({
    propTypes: {
        params: React.PropTypes.object,
        routeParams: React.PropTypes.object
    },

    getInitialState() {
        let activeStep = (window.localStorage.getItem('current_step') ? window.localStorage.getItem('current_step') : 0);
       
        return {
            activeStep,
            currentStepName: null,
            currentStepTitle: null,
            currentStepQuestions: [],
            currentStepNumber: 1,
            totalNumberOfSteps: StepManager.totalNumberOfSteps(),
            stepHeaders: StepManager.getSteps(),
            generatingQuote: false,
            displayErrors: null
        };
    },

    componentWillMount() {
        ReactGA.initialize('UA-1926380-5');
        window.addEventListener('popstate', function(event) {
            event;
        }, false);
    },

    componentDidMount() {
       
       
       
        if (Questions.hasStep1()) {
            this.moveToStep(this.state.activeStep);
        } else {
            browserHistory.push('/start');
        }
    },

    componentDidUpdate() {
        this.setPageTitle();
    },

    componentWillUnmount() {
    },
    

    questionComponents : {},

    setPageTitle() {
        document.title = 'Step '+(parseInt(this.state.currentStepNumber)+1)+' - '+this.state.currentStepTitle;
    },

    testStepComplete(questions) {
        let somethingFailed = false;
        $.each(questions, function(k, v) {
            if (v.parent === false) {
                if (!Quote.hasAnswers(v.field_name)) {
                    somethingFailed = true;
                }
            }
        });
        return (somethingFailed) ? false : true;
    },

    getInvalidQuestions() {
        let invalidFieldNames = this.state.currentStepQuestions.map(function(i) {
            let children = Questions.getChildQuestions(i.id, Quote.getCurrentAnswer(i.field_name));
            if (children) {
                children.map(function(child) {
                    if (!Quote.getCurrentAnswer(child.field_name) || Quote.getCurrentAnswer(child.field_name) == '') {
                        return child.field_name;
                    }
                });
            }
            if (i.field_name !== 'cor' && !Quote.hasAnswers(i.field_name)) {
                return i.field_name;
            } else if (i.field_name === 'cor' && !Quote.hasAnswers('cor', 'cor_address_line1', 'cor_address_postcode')) {
                return i.field_name;
            }
            if (Quote.getCurrentAnswer('is_cor_address_uk') == 'no' && i.field_name === 'cor' && !Quote.hasAnswer('country')) {
                return 'cor';
            }
        }).filter(function(fieldName) {
            return fieldName !== '' || fieldName !== null || fieldName !== undefined;
        });

        return invalidFieldNames;
    },

    moveToStep(requestedStep) {
        // Set a record in the browser history and scroll to the top
        window.history.pushState({ step: this.state.currentStepNumber }, document.title, '/questions');
        window.scrollTo(0, 0);

        // Set up a variable for the 'visible' step number
        let visibleStepNumber;

        // Determine the correct 'step number' for the transition
        // /start being 1, and so on.
        if (requestedStep === 'start') {
            browserHistory.push('/start');
            visibleStepNumber = 1;
        } else {
            requestedStep = parseInt(requestedStep);
            visibleStepNumber = requestedStep + 2;
        }

        // Push event to GA
        ReactGA.event({
            category: 'Landlord Insurance',
            action: 'Step'  + visibleStepNumber,
            label: 'Quote Form'
        });

        if (StepManager.canMoveToStep(requestedStep)) {
            let steps = Questions.getSteps();
            let questionsArray = [];
            let adjustedCurrentStepName = '';
            let adjustedCurrentStepTitle = '';

            steps.map(function(step, index) {
                if (requestedStep === index) {
                    adjustedCurrentStepName = step.name,
                    adjustedCurrentStepTitle = step.title,
                    // build the questions array to push to state.currentStepQuestions
                    $.each(step.questions, function(k, v) {
                        if (v.parent === false) {
                            questionsArray.push(v);
                        }
                    });
                }
            }, this);

            // Persist our updated state
            this.setState({
                activeStep: requestedStep,
                currentStepQuestions: questionsArray,
                currentStepNumber: parseInt(requestedStep)+1,
                currentStepName: adjustedCurrentStepName,
                currentStepTitle: adjustedCurrentStepTitle,
                showLoading: false
            });
        }
    },

    moveBack() {

        this.setState({
            displayErrors: null
        });

        if (this.state.currentStepNumber === 1) {
            browserHistory.push('/start');
        } else {
            // Arrays start at zero. This is also adjusted by two due to '/start' being 1
            this.moveToStep(parseInt(this.state.currentStepNumber)-2);
        }
        this.onReRender();
    },

    moveForward() {
        let nextStep = parseInt(this.state.currentStepNumber);

        let components = [];
        let self = this;

        Object.keys(self.questionComponents).forEach(function(key) {
            const c = self.questionComponents[key];
            if (c !== null) {
                components.push(c);
                if (c.getChildComponents) {
                    components.push(...c.getChildComponents());
                }
            }
        });

        const isInvalid = components
            .filter(c => c != null)
            .map(c => c.doValidation())
            .some(c => c === false);

        if (isInvalid) {
            return false;
        }

        if (StepManager.canMoveToStep(this.state.currentStepNumber)) {
            this.moveToStep(nextStep);
        }
        this.onReRender();
    },

    generateQuote: function() {
        let components = [];
        let self = this;

        Object.keys(self.questionComponents).forEach(function(key) {
            const c = self.questionComponents[key];
            if (c !== null) {
                components.push(c);
                if (c.getChildComponents) {
                    components.push(...c.getChildComponents());
                }
            }
        });

        const isInvalid = components
            .filter(c => c != null)
            .map(c => c.doValidation())
            .some(c => c === false);

        if (isInvalid) {
            return false;
        }

        this.setState({
            generatingQuote: true,
        });

        Quote.generateQuote(Config.api.quote.method, Config.api.quote.url).then(
        function(s){
            if (s.referral == 'warning') {
                QuoteError.set(QuoteError.STATUS_PRE_REFERRAL, s.referral_reasons, s.quoteNumber);
                // @TODO naming inconsistent, fix in API
                Quote.set('policyNumber', s.quoteNumber);
                browserHistory.push('/pre-referral');
            } else if (s.referral == 'confirmation') {
                QuoteError.set(QuoteError.STATUS_REFERRAL, s.referral_reasons, s.quoteNumber);
                browserHistory.push('/quote-referred');
            } else if (typeof s.results === 'object') {
                Quote.set('policyNumber', s.results.policyNumber);
                Quote.cacheQuote(s.results);
                browserHistory.push('/quote');
            }
        },
        function(e) {
            if (e.status === 500) {
                QuoteError.set(QuoteError.getStatusFromString(e.responseJSON.error), e.responseJSON.error, null);
                browserHistory.push('/quote-recoverable-issue');
            }
        });
    },

    /**
     * runs every time after a new step is rendered
     * this is the worst code i've ever written, sorry
     * this function is primarily used for if a user has just logged in
     * or out of My HomeLet, and we need to disable some fields
     */
    onReRender() {
        // @TODO possibly remove
    },

    forceRerender() {
        this.forceUpdate();
        this.onReRender();
    },
    render() {
        let self = this;
        let displayerrors = [];
        if (this.state.displayErrors !== null) {
            this.state.displayErrors.map(function(v, index) {
                let q = Questions.getQuestionTitleByFieldName(v);
                displayerrors.push(<li key={index+'_'+Questions.guid()}>{q.question}</li>);
            }, this);
        }
        return (
            <div>
                <GlobalHeader />
                <HeaderSteps
                    steps={this.state.stepHeaders}
                    onReRender={this.onReRender}
                    current={this.state.activeStep}
                    totalNumberOfSteps={this.state.stepHeaders.length}
                    complete={0}
                    hasQuote={Quote.hasQuote()}
                    moveTo={this.moveToStep}
                />

                {  

                (this.state.currentStepNumber == 1 )? <Popup trigger={true}> 
                </Popup>: null 
                } 



                {this.state.displayErrors !== null ?
                    <div className="container pageValidationErrors">
                        <p>Please answer the following questions:</p>
                        <ul>{displayerrors}</ul>
                    </div>
                : null }

                <question-row class="no-border unpadded">
                    <h1>{this.state.currentStepTitle}</h1>
                </question-row>

                {this.state.currentStepQuestions.map(function(q, index){
                    return(
                        <div key={index+'_'+Questions.guid()}>
                            {q.type === 'money' ?
                            <MoneyInput
                                question={q.question}
                                fieldName={q.field_name}
                                helpText={q.hint_text}
                                supplementaryId={q.supplementary_id}
                                inputMask="9999999"
                                alternateBackground={q.is_alternate_background}
                                noBorder={q.is_borderless}
                                ref={function(component) {
                                    self.questionComponents[q.field_name] = component;
                                }}
                            />
                            : null}

                            {q.type === 'select' ?
                            <SelectElement
                                question={q.question}
                                options={q.options}
                                fieldName={q.field_name}
                                questionId={String(q.question_id)}
                                children={q.display_dependencies}
                                helpText={q.hint_text}
                                alternateBackground={q.is_alternate_background}
                                noBorder={q.is_borderless}
                                defaultValue={null}
                                ref={function(component) {
                                    self.questionComponents[q.field_name] = component;
                                }}
                            />
                            : null}

                            {q.type === 'radio' ?
                            <ButtonChoice
                                question={q.question}
                                fieldName={q.field_name}
                                loadCachedValue={true}
                                options={q.options}
                                questionId={q.question_id}
                                children={q.display_dependencies}
                                supplementaryText={q.supplementary_html}
                                supplementaryTextAfterInput={q.supplementary_after_question}
                                alternateBackground={q.is_alternate_background}
                                noBorder={q.is_borderless}
                                helpText={q.hint_text}
                                ref={function(component) {
                                    self.questionComponents[q.field_name] = component;
                                }}
                                />
                            : null}

                            {q.type === 'string' ?
                            <TextInput
                                question={q.question}
                                fieldName={q.field_name}
                                supplementaryId={q.supplementary_id}
                                loadCachedValue={true}
                                maxLength={50}
                                helpText={q.hint_text}
                                alternateBackground={q.is_alternate_background}
                                noBorder={q.is_borderless}
                                ref={function(component) {
                                    self.questionComponents[q.field_name] = component;
                                }}
                             />
                            : null}

                            {q.type === 'number' ?
                            <NumberInput
                                question={q.question}
                                fieldName={q.field_name}
                                loadCachedValue={true}
                                maxLength={11}
                                helpText={q.hint_text}
                                alternateBackground={q.is_alternate_background}
                                noBorder={q.is_borderless}
                                ref={function(component) {
                                    self.questionComponents[q.field_name] = component;
                                }}
                            />
                            : null}

                            {q.type === 'postcode' || q.type === 'hidden' ?
                            <TextInput
                                question={q.question}
                                fieldName={q.field_name}
                                loadCachedValue={true}
                                maxLength={q.type === 'postcode' ? 10 : 50}
                                helpText={q.hint_text}
                                alternateBackground={q.is_alternate_background}
                                noBorder={q.is_borderless}
                                ref={function(component) {
                                    self.questionComponents[q.field_name] = component;
                                }}
                             />
                            : null}

                            {q.type === 'country' ?
                            <CountrySelectElement
                                question={q.question}
                                options={q.options}
                                fieldName={q.field_name}
                                helpText={q.hint_text}
                                defaultValue="Please select..."
                                alternateBackground={q.is_alternate_background}
                                noBorder={q.is_borderless}
                            />
                            : null}

                            {q.type === 'address' && !q.field_name == 'cor' ?
                            <AddressEntry
                                fieldNamePrefix={q.field_name}
                                pafLookup={true}
                                postcodeFunction={this.getRiskArea}
                                question={q.question}
                                helpText={q.hint_text}
                                alternateBackground={q.is_alternate_background}
                                noBorder={q.is_borderless}
                                ref={function(component) {
                                    self.questionComponents[q.field_name] = component;
                                }}
                            /> : null}

                            {q.type === 'address' && q.field_name == 'cor' ?
                            <CorAddressEntry
                                fieldNamePrefix={q.field_name}
                                pafLookup={true}
                                postcodeFunction={this.getRiskArea}
                                question={q.question}
                                helpText={q.hint_text}
                                alternateBackground={q.is_alternate_background}
                                noBorder={q.is_borderless}
                                ref={function(component) {
                                    self.questionComponents[q.field_name] = component;
                                }}
                            /> : null}

                            {q.type === 'email' ?
                            <EmailInput
                                forceRerender={this.forceRerender}
                                question={q.question}
                                fieldName={q.field_name}
                                loadCachedValue={true}
                                helpText={q.hint_text}
                                alternateBackground={q.is_alternate_background}
                                noBorder={q.is_borderless}
                                ref={function(component) {
                                    self.questionComponents[q.field_name] = component;
                                }}
                             />
                            : null}

                            {q.type === 'dob' ?
                            <DateOfBirth
                                question={q.question}
                                fieldName={q.field_name}
                                loadCachedValue={true}
                                helpText={q.hint_text}
                                alternateBackground={q.is_alternate_background}
                                noBorder={q.is_borderless}
                                ref={function(component) {
                                    self.questionComponents[q.field_name] = component;
                                }}
                             />
                            : null}

                            {q.type === 'declaration' ?
                            <ButtonChoice
                                question={q.question}
                                fieldName={q.field_name}
                                loadCachedValue={true}
                                questionId={q.question_id}
                                supplementaryText={q.supplementary_html}
                                supplementaryTextAfterInput={q.supplementary_after_question}
                                alternateBackground={q.is_alternate_background}
                                noBorder={q.is_borderless}
                                helpText={q.hint_text}
                                ref={function(component) {
                                    self.questionComponents[q.field_name] = component;
                                }}
                                options={[
                                    {
                                        option_text: 'Yes',
                                        option_value: 'yes'
                                    },
                                    {
                                        option_text: 'No',
                                        option_value: 'no'
                                    }
                                ]} />
                            : null}

                            {q.type === 'boolean' ?
                            <ButtonChoice
                                question={q.question}
                                fieldName={q.field_name}
                                loadCachedValue={true}
                                children={q.display_dependencies}
                                questionId={q.question_id}
                                supplementaryText={q.supplementary_html}
                                supplementaryTextAfterInput={q.supplementary_after_question}
                                alternateBackground={q.is_alternate_background}
                                noBorder={q.is_borderless}
                                helpText={q.hint_text}
                                ref={function(component) {
                                    self.questionComponents[q.field_name] = component;
                                }}
                                options={[
                                    {
                                        option_text: 'Yes',
                                        option_value: 'yes'
                                    },
                                    {
                                        option_text: 'No',
                                        option_value: 'no'
                                    }
                                ]} />
                            : null}

                            {q.type === 'previous_claim' ?
                                <PreviousClaimChoice
                                    question={q.question}
                                    fieldName={q.field_name}
                                    loadCachedValue={true}
                                    children={q.display_dependencies}
                                    questionId={q.question_id}
                                    supplementaryText={q.supplementary_html}
                                    supplementaryTextAfterInput={q.supplementary_after_question}
                                    alternateBackground={q.is_alternate_background}
                                    noBorder={q.is_borderless}
                                    helpText={q.hint_text}
                                    ref={function(component) {
                                        self.questionComponents[q.field_name] = component;
                                    }}
                                    options={[
                                        {
                                            option_text: 'Yes',
                                            option_value: 'yes'
                                        },
                                        {
                                            option_text: 'No',
                                            option_value: 'no'
                                        }
                                    ]} />

                            : null}
                        </div>
                    );
                }, this)}


                {(ProductCover.isNotRentGuaranteeOrLegal()) && this.state.currentStepNumber === 1 ?
                    <div className="alternate-background">
                        <question-row class="no-border unpadded footer-text">
                            <div>
                                <p>For full Exclusions, Limitations and Conditions please refer to the <a href={'https://homelet.co.uk/-/media/project/barbon/homelet/homelet-documents/landlords-policy-wordings/landlords-plus-documents/b151-homelet-ll-policy-wording-0225-v1.pdf'} target={'_blank'}>Policy Wording</a>.</p>
                                <p>It&rsquo;s important to check that the sum insured is adequate. If it&rsquo;s too low, a claim may not be paid in full or even at all. If you want any more information on the consequences of under insurance, please call us on 0800 038 4574</p>
                            </div>
                        </question-row>
                    </div>
                : null}

                {
                    ((ProductCover.isNotRentGuaranteeOrLegal()) && this.state.currentStepNumber === 3) ||
                    ((ProductCover.hasRentGuaranteeOrLegal()) && this.state.currentStepNumber === 2) ?
                    <question-row class="no-border unpadded relative">
                        <img src="https://barbon-images.s3-eu-west-1.amazonaws.com/Feefo_Landlady_2017_V2.svg" alt="Feefo rating for our landlord insurance product" className="character-image" />
                    </question-row>
                    : null
                }

                {
                    ((ProductCover.isNotRentGuaranteeOrLegal()) && this.state.currentStepNumber === 0) ||
                    ((ProductCover.hasRentGuaranteeOrLegal()) && this.state.currentStepNumber === 0) ?
                        <DataProtection />
                    : null
                }

                {
                    ((ProductCover.isNotRentGuaranteeOrLegal()) && this.state.currentStepNumber === 4) ||
                    ((ProductCover.hasRentGuaranteeOrLegal()) && this.state.currentStepNumber === 2) ?
                        <div className="alternate-background">
                            <question-row class="no-border unpadded relative">
                                <div className="content-block">
                                    <h2>Terms &amp; Conditions</h2>
                                    <p>By continuing you are confirming that:</p>
                                    <ul>
                                        <li>The above statements are true and complete. 
                                        </li>
                                        <li> You understand that if the policy information is incorrect or incomplete that this insurance may not protect 
                                            you in the event of a claim or could result in the policy being invalid.
                                        </li>
                                        <li>
                                            You agree to inform us of any changes to your situation which may impact your insurance. 
                                            Failure to do so may mean that your policy doesn't offer adequate protection or may invalidate the policy.
                                        </li>
                                    </ul>
                                </div>
                            </question-row>
                        </div>
                        : null
                }

                <question-row class="no-border">
                    <SubmitButton
                        label={this.state.currentStepNumber === this.state.totalNumberOfSteps ? 'Agree & Continue' : 'Next'}
                        backLink={this.moveBack}
                        loading={this.state.generatingQuote}
                        onClick={this.state.currentStepNumber === this.state.totalNumberOfSteps ? this.generateQuote : this.moveForward}
                    />
                </question-row>
            </div>
        );
    }
});

export default QuestionsScreen;



/** WEBPACK FOOTER **
 ** ./src/components/Screens/QuestionsScreen.js
 **/